import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mine_rights_time",
  "use": "icon-mine_rights_time-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-mine_rights_time\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h36v36H0z\" /><path d=\"M18 33C9.716 33 3 26.285 3 18 3 9.716 9.716 3 18 3c8.285 0 15 6.716 15 15 0 8.285-6.715 15-15 15Zm0-3c6.627 0 12-5.373 12-12S24.627 6 18 6 6 11.373 6 18s5.373 12 12 12Zm1.5-12h6v3h-9V10.5h3V18Z\" fill=\"#FF8D00\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol